(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shelf-weight-table"] && !Shopify.designMode) return;
  try {
    
  class ShelfWeightCalc extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('.shelf-weight__slider');
      if (!this.slider) return;

      this.lengthOutput = this.querySelector('[data-readout-length]');
      this.capacityOutput = this.querySelector('[data-readout-capacity]');
      this.studsOutput = this.querySelector('[data-readout-studs]');

      this.lbsPerStud = parseFloat(this.dataset.lbsPerStud) || 50;
      this.inchesPerStud = parseFloat(this.dataset.inchesPerStud) || 24;
      this.maxStuds = parseInt(this.dataset.maxStuds, 10) || 3;

      this.slider.addEventListener('input', this.update.bind(this));
      this.classList.add('is-ready');
      this.update();
    }

    update() {
      const min = parseFloat(this.slider.min);
      const max = parseFloat(this.slider.max);
      const length = parseInt(this.slider.value, 10);

      let studs = Math.round(length / this.inchesPerStud);
      if (studs < 1) studs = 1;
      if (studs > this.maxStuds) studs = this.maxStuds;
      const capacity = studs * this.lbsPerStud;

      if (this.lengthOutput) this.lengthOutput.textContent = length;
      if (this.capacityOutput) this.capacityOutput.textContent = capacity;
      if (this.studsOutput) {
        this.studsOutput.textContent = studs === 1 ? '1 stud' : studs + ' studs';
      }

      this.slider.setAttribute(
        'aria-valuetext',
        length + ' inch shelf holds up to ' + capacity + ' pounds'
      );

      const pct = max > min ? ((length - min) / (max - min)) * 100 : 0;
      this.slider.style.setProperty('--shelf-weight-fill', pct + '%');
    }
  }

  if (!customElements.get('shelf-weight-calc')) {
    customElements.define('shelf-weight-calc', ShelfWeightCalc);
  }

  } catch(e) { console.error(e); }
})();
})();
